import { debugLogs } from 'utils/common';
import { checkJarvisIsAdActive } from 'helpers/ads/utils';

const checkJarvisAdActiveAndGetConfigFn = (name, config = {}) => {
  const revData = window?.App?.state?.revenue?.data?.ads;
  if (revData && revData[name]) {
    return { ...config, ...revData[name] };
  }
  return config;
};
const checkJarvisAdActiveAndGetConfig = name => {
  const config = checkJarvisIsAdActive(name);
  if (!config) {
    return null;
  }
  return checkJarvisAdActiveAndGetConfigFn(name, config);
};

const differceIsHigh = (balls, diff, scoreTriggerAd) => {
  try {
    for (let i = 0; i < diff; i += 1) {
      const element = balls[i];
      if (!element) {
        return false;
      }
      debugLogs(
        `$$$$ Run-${element.runs} | over-${element.over} | ballNo-${
          element.number
        }`,
      );
      if (element && scoreTriggerAd.includes(element.runs)) {
        return true;
      }
    }
    return false;
  } catch (error) {
    debugLogs(error);
    return false;
  }
};

const reloadDfpAdFn = adobj => {
  const slot = window.googletag
    .pubads()
    .getSlots()
    .find(
      slotItem => adobj.divId && slotItem.getSlotElementId() === adobj.divId,
    );
  if (slot) {
    window.googletag.pubads().refresh([slot]);
  } else {
    window.displayAllAdsInArray([adobj]);
  }
};

const showCricketAdPopup = (show, adobj) => {
  const { divId } = adobj;
  let popupEle = document.querySelector(`.cricketAdPopup`);
  if (!popupEle) {
    const wrapper = document.createElement('div');
    wrapper.className = 'cricketAdPopup';
    const child = document.createElement('div');
    child.id = divId;
    wrapper.appendChild(child);
    document.body.appendChild(wrapper);
    popupEle = wrapper;
  }
  if (show) {
    popupEle.classList.add('show');
  } else {
    popupEle.classList.remove('show');
  }
};

const reloadDfpAd = (adobj, name) => {
  const fn = window?._dfpObj?.reloadDfpAdFn || reloadDfpAdFn;
  fn(adobj, name);
};
const updateAdTrigger = (adobj, callback, obj) => {
  const adTrigger = !!obj;

  switch (adobj?.layout) {
    case 'flip':
      callback({ adTrigger });
      break;
    case 'popup':
      showCricketAdPopup(adTrigger, adobj);
      break;
    default:
      callback(obj);
      break;
  }
};
const displayScorecardAd = (callback, adTimeout = 10, adobj, name) => {
  try {
    updateAdTrigger(adobj, callback, {});
    reloadDfpAd(adobj, name);
    setTimeout(() => {
      updateAdTrigger(adobj, callback, null);
    }, adTimeout * 1000);
  } catch (error) {
    debugLogs(error);
  }
};

const cricketWidgetAd = (scorecard, widgetad, callback) => {
  try {
    const statusMatchEnded = ['Play In Progress'];
    if (
      typeof window !== 'undefined' &&
      scorecard &&
      statusMatchEnded.includes(scorecard?.matchStatus) &&
      scorecard?.innings?.length
    ) {
      debugLogs(`$$$$ Jarvis caimpaign is active`);
      const curentInn = scorecard.innings.length - 1;
      const currentInning = scorecard.innings[curentInn];
      if (!currentInning) {
        debugLogs(`$$$$ Wrong inning Found`);
        return;
      }
      const { balls, number } = currentInning.ballByBall[0];
      const { runs, number: ballNo } = balls[0];
      const alreadyDisplayAd = `${curentInn}_${number}_${ballNo}`;
      if (typeof window !== 'undefined' && !window.alreadyDisplayAd) {
        window.alreadyDisplayAd = '';
      }
      if (
        typeof window !== 'undefined' &&
        alreadyDisplayAd !== window.alreadyDisplayAd
      ) {
        const lastBallNo = window.alreadyDisplayAd.split('_')[2];
        const lastOver = window.alreadyDisplayAd.split('_')[1];
        window.alreadyDisplayAd = alreadyDisplayAd;
        debugLogs(
          `$$$$ Run-${runs} | over-${number} | ballNo${ballNo} | finalid-${alreadyDisplayAd} | lastBallNo_${lastBallNo}`,
        );
        const diff = lastBallNo ? ballNo - lastBallNo : 0;
        const overdiff = lastOver ? number - lastOver : 0;
        debugLogs(`$$$$ diff - ${diff}  | overdiff - ${overdiff}`);
        let call = false;
        const { scoreTriggerAd, adTimeout } = widgetad;
        if (scoreTriggerAd.includes(runs)) {
          call = true;
        } else if (overdiff > 0) {
          const lastballs = currentInning.ballByBall[1].balls;
          const findInd = lastballs.findIndex(l => lastBallNo === l.number);
          call = differceIsHigh(lastballs, findInd, scoreTriggerAd);
          if (!call) {
            call = differceIsHigh(balls, ballNo + 1, scoreTriggerAd);
          }
        } else if (diff > 1) {
          call = differceIsHigh(balls, diff, scoreTriggerAd);
        }
        if (call) {
          debugLogs(`$$$$ it a four or one | call ad`);
          displayScorecardAd(
            callback,
            adTimeout,
            widgetad,
            'scorecard_widget_ad',
          );
        }
      } else {
        debugLogs(`$$$$ alreadyDisplayAd Same Last ball`, alreadyDisplayAd);
      }
    } else {
      debugLogs(
        `$$$$ match is not Active but caimpaign is active  | widgetad - `,
        widgetad,
      );
    }
  } catch (error) {
    debugLogs(error);
  }
};

export { cricketWidgetAd, displayScorecardAd, checkJarvisAdActiveAndGetConfig };
